const initialState = {
  currentUser: {},
  hijackerUser: {},
  addReceiver: {
    data: [],
    loading: false,
    error: null,
  },
  verifyReceiver: {
    loading: false,
    error: null,
  },
  sendVerifyCodeAgain: {
    loading: false,
    error: null,
  },
  removeReceiver: {
    loading: false,
    error: null,
  },
  changeAvatar: {
    loading: false,
    error: null,
  },
};

export default initialState;
